<template>
  <div>
    <div class="section section--half-y-padding">
      <h2 class="title title--2 no-wrap">
        {{ content.OpenTabPaymentMethod.title }}
      </h2>
    </div>

    <div class="section">
      <radio-input
        v-model="isPayNow"
        vertical
        name="paymentMethod"
        radio-style="icon-box"
        label="Payment Method"
        label-style="hidden"
        :options="options"
      />

      <button
        type="button"
        class="button button--primary"
        :disabled="isPayNow === undefined"
        @click="handleContinue"
      >
        {{ content.OpenTabPaymentMethod.metadata.paymentMethodCta }}
      </button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'OpenTabFinishOrdering',

    data() {
      return {
        isPayNow: undefined
      };
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('orders', ['order']),
      ...mapGetters('session', ['session']),

      options() {
        return [
          {
            value: true,
            display: this.content.OpenTabPaymentMethod.metadata.checkoutTitle,
            subDisplay: this.content.OpenTabPaymentMethod.metadata.checkoutSubtitle,
            icon: 'fa-credit-card-front'
          },
          {
            value: false,
            display: this.content.OpenTabPaymentMethod.metadata.openTabTitle,
            subDisplay: this.content.OpenTabPaymentMethod.metadata.openTabSubtitle,
            icon: 'fa-file-alt'
          }
        ];
      }
    },

    methods: {
      handleContinue() {
        this.$closeAllModals();

        if (this.isPayNow) {
          this.$router.push({
            name: 'payAtTableCheckout',
            params: {
              merchantId: this.$route.params.merchantId
            },
            query: {
              ml: this.session.route.merchantLocationId,
              oi: this.order.orderId,
              tb: this.session.route.tableNumber
            }
          });
        }
      }
    }
  };
</script>
